import Client1 from "../assets/client-6.png";
import Client2 from "../assets/client-6.png";
import Client3 from "../assets/client-6.png";
import Client4 from "../assets/client-6.png";
import Client5 from "../assets/client-6.png";
import Client6 from "../assets/client-6.png";
import Client7 from "../assets/client-6.png";
import Client8 from "../assets/client-6.png";
import Slide1 from "../assets/1.jpeg";
import Slide2 from "../assets/2.jpg";

import { fetchPropertyData, fetchAgentsData, fetchUserImage } from "../Route";

export const newsData = [
  {
    id: 1,
    image: "/2.jpg",
    title: "10 Brilliant Ways To Decorate Your Home",
    author: "Admin",
    category: "Decorate",
    date: "June 24, 2021",
    link: "/news/1",
  },
  {
    id: 2,
    image: "/1.jpg",
    title: "The Most Inspiring Interior Design Of 2021",
    author: "Admin",
    category: "Interior",
    date: "July 23, 2021",
    link: "/news/2",
  },
  {
    id: 3,
    image: "/2.jpg",
    title: "Recent Commercial Real Estate Transactions",
    author: "Admin",
    category: "Estate",
    date: "May 22, 2021",
    link: "/news/3",
  },
  {
    id: 4,
    image: "/1.jpg",
    title: "Modern Kitchen Design Trends",
    author: "Admin",
    category: "Kitchen",
    date: "March 10, 2022",
    link: "/news/4",
  },
  {
    id: 5,
    image: "/2.jpg",
    title: "How to Design a Perfect Home Office",
    author: "Admin",
    category: "Workspaces",
    date: "April 18, 2022",
    link: "/news/5",
  },
  {
    id: 6,
    image: "/1.jpg",
    title: "Luxury Living: Designing a High-End Home",
    author: "Admin",
    category: "Luxury",
    date: "May 5, 2022",
    link: "/news/6",
  },
  {
    id: 7,
    image: "/2.jpg",
    title: "Creating a Stunning Outdoor Living Space",
    author: "Admin",
    category: "Outdoor",
    date: "June 15, 2022",
    link: "/news/7",
  },
  {
    id: 8,
    image: "/1.jpg",
    title: "Bathroom Design Ideas for Small Spaces",
    author: "Admin",
    category: "Bathroom",
    date: "July 8, 2022",
    link: "/news/8",
  },
  {
    id: 9,
    image: "/2.jpg",
    title: "Smart Home Innovations for 2023",
    author: "Admin",
    category: "Technology",
    date: "August 20, 2022",
    link: "/news/9",
  },
];

export const getPropertyData = async () => {
  try {
    const data = await fetchPropertyData();

    if (!Array.isArray(data)) {
      // console.error("Unexpected data format. Expected an array but got:", data);
      return [];
    }

    // console.log(`Total properties received: ${data.length}`);
    return data;
  } catch (error) {
    // console.error("Error processing property data:", error.message);
    return [];
  }
};

export const contactInfo = [
  {
    icon: "bi-envelope",
    title: "Email Address",
    external: false,
    details: [
      {
        label: "urbanview@urbanviewre.com",
        href: "mailto:urbanview@urbanviewre.com",
      },
    ],
  },
  {
    icon: "bi-telephone",
    title: "Phone Number",
    external: false,
    details: [
      {
        label: "0424 955 982",
        href: "tel:+61424955982",
      },
    ],
  },
  {
    icon: "bi-geo-alt",
    title: "Office Address",
    external: true,
    details: [
      {
        label: "5/429 High Street, Penrith, NSW 2750",
        href: "https://maps.app.goo.gl/FBD2dUcNLPMs7KzS7",
      },
    ],
  },
];

export const servicesData = [
  {
    id: 1,
    title: "Buy / Sell a home",
    description:
      "Whether you're buying or selling a home, our experienced agents are here to assist you from listing to closing.",
    linkText: "View More →",
    linkColor: "text-primary",
    icon: "bi bi-house-door",
  },
  {
    id: 2,
    title: "Rent a home",
    description:
      "Over 1 million+ homes for sale available on the website, we can match you with a house you will want to call home.",
    linkText: "View More →",
    linkColor: "text-danger",
    icon: "bi bi-cash-coin",
  },
  {
    id: 3,
    title: "Manage Property",
    description:
      "Trust us for complete investment property management: tenant screening, maintenance, financial reporting.",
    linkText: "View More →",
    linkColor: "text-primary",
    icon: "bi bi-house",
  },
  {
    id: 4,
    title: "Mortgage Service",
    description:
      "Get the best home loan with expert guidance. We simplify the process, offering competitive rates and tailored solutions to meet your financial goals",
    linkText: "View More →",
    linkColor: "text-success",
    icon: "bi bi-bank",
  },
  {
    id: 5,
    title: "Consulting Service",
    description:
      "Expert property consulting from planning to construction. Get financial, design, and building advice to make informed decisions for a stress-free experience.",
    linkText: "View More →",
    linkColor: "text-warning",
    icon: "bi bi-chat-dots",
  },
  {
    id: 6,
    title: "Home & Land Packages",
    description:
      "Discover affordable home & land packages for first-time buyers and investors. A hassle-free solution to owning a stylish, modern home in prime locations.",
    linkText: "View More →",
    linkColor: "text-info",
    icon: "bi bi-shield-lock",
  },
  {
    id: 7,
    title: "Custom Home Design",
    description:
      "Create your dream home with unique, stylish, and functional designs. We tailor every detail to reflect your vision while ensuring comfort and efficiency.",
    linkText: "View More →",
    linkColor: "text-info",
    icon: "bi bi-shield-lock",
  },
  {
    id: 8,
    title: "Knock Down Rebuild",
    description:
      "Rebuild your dream home on your existing land. Upgrade to a modern, energy-efficient home while maximizing space, style, and property value.",
    linkText: "View More →",
    linkColor: "text-info",
    icon: "bi bi-shield-lock",
  },
  {
    id: 9,
    title: "Dual Occupancy & Duplex",
    description:
      "Build smart with dual occupancy or duplex designs. Ideal for rental income or multi-living, these high-yield solutions maximize space and investment returns.",
    linkText: "View More →",
    linkColor: "text-info",
    icon: "bi bi-shield-lock",
  },
  {
    id: 10,
    title: "Renovations",
    description:
      "Upgrade your home with expert renovations, enhancing aesthetics, functionality, and value through high-quality craftsmanship, from kitchens to remodels",
    linkText: "View More →",
    linkColor: "text-info",
    icon: "bi bi-shield-lock",
  },
  {
    id: 11,
    title: "High Value Inclusions",
    description:
      "High Value Inclusions delivers premium real estate services, offering luxury properties with top-tier amenities and exceptional investment opportunities.",
    linkText: "View More →",
    linkColor: "text-info",
    icon: "bi bi-shield-lock",
  },
];

export const carouselImages = [
  Slide1,
  Slide2,
  Slide1,
  Slide2,
  Slide1,
];

export const Clients = [
  Client1,
  Client2,
  Client3,
  Client4,
  Client5,
  Client6,
  Client7,
  Client8,
];

export const getPropertyListData = async () => {
  try {
    const properties = await fetchPropertyData();
    
    // Filter only active properties
    const activeProperties = properties.filter(property => property.status === "Active");
    
    // console.log(`Total properties: ${properties.length}`);
    // console.log(`Active properties: ${activeProperties.length}`);
    // console.log(`Inactive properties: ${properties.length - activeProperties.length}`);
    
    return activeProperties;
  } catch (error) {
    console.error("Error processing property data:", error);
    return [];
  }
};

export const testimonialsData = [
  {
    id: 1,
    image: "/profile.jpg",
    name: "Ethan James",
    role: "Property Seeker",
    feedback:
      "High Value Inclusions made my property search seamless. Their curated listings and expert guidance helped me find my dream home effortlessly! ",
  },
  {
    id: 2,
    image: "/profile.jpg",
    name: "Sophia Williams",
    role: "Invester",
    feedback:
      "Their market insights and exclusive investment opportunities have been invaluable. I secured high-yield properties with great appreciation potential.",
  },
  {
    id: 3,
    image: "/profile.jpg",
    name: "Liam Johnson",
    role: "Home Buyer",
    feedback:
      "Navigating the home-buying process was stress-free with their support. They explained everything clearly and helped me make the right decision.",
  },
  {
    id: 4,
    image: "/profile.jpg",
    name: "Olivia Brown",
    role: "Land Seeker",
    feedback:
      "Finding the perfect land for my future project was easy. They provided prime options with excellent growth potential and clear documentation.",
  },
  {
    id: 5,
    image: "/profile.jpg",
    name: "James Anderson",
    role: "Commercial Property Investor",
    feedback:
      "Their expertise in commercial real estate helped me secure a high-ROI property in a prime location. Highly recommended!",
  },
];

export const getAgentsData = async () => {
  try {
    const response = await fetchAgentsData();
    // console.log("Fetched agents data:", response);
    return response?.data || [];
  } catch (error) {
    // console.error("Error processing agents data:", error);
    return [];
  }
};

export const faqs = [
  {
    id: 1,
    question: "How to buy a product?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Proin libero nunc consequat interdum. Condimentum lacinia quis vel eros donec ac. Mauris sit amet massa vitae tortor. Quisque id diam vel quam elementum pulvinar. Gravida in fermentum et sollicitudin ac orci phasellus. Facilisis gravida neque convallis a cras semper. Non arcu risus quis varius quam quisque id.",
  },
  {
    id: 2,
    question: "How can I make a refund from your website?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Proin libero nunc consequat interdum. Condimentum lacinia quis vel eros donec ac. Mauris sit amet massa vitae tortor. Quisque id diam vel quam elementum pulvinar. Gravida in fermentum et sollicitudin ac orci phasellus. Facilisis gravida neque convallis a cras semper. Non arcu risus quis varius quam quisque id.",
  },
  {
    id: 3,
    question: "I am a new user. How should I start?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Proin libero nunc consequat interdum. Condimentum lacinia quis vel eros donec ac. Mauris sit amet massa vitae tortor. Quisque id diam vel quam elementum pulvinar. Gravida in fermentum et sollicitudin ac orci phasellus. Facilisis gravida neque convallis a cras semper. Non arcu risus quis varius quam quisque id.",
  },
  {
    id: 4,
    question: "Returns and refunds",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Proin libero nunc consequat interdum. Condimentum lacinia quis vel eros donec ac. Mauris sit amet massa vitae tortor. Quisque id diam vel quam elementum pulvinar. Gravida in fermentum et sollicitudin ac orci phasellus. Facilisis gravida neque convallis a cras semper. Non arcu risus quis varius quam quisque id.",
  },
  {
    id: 5,
    question: "Are my details secured?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Proin libero nunc consequat interdum. Condimentum lacinia quis vel eros donec ac. Mauris sit amet massa vitae tortor. Quisque id diam vel quam elementum pulvinar. Gravida in fermentum et sollicitudin ac orci phasellus. Facilisis gravida neque convallis a cras semper. Non arcu risus quis varius quam quisque id.",
  },
  {
    id: 6,
    question: "Sale code is not working",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Scelerisque eleifend donec pretium vulputate sapien nec sagittis. Proin libero nunc consequat interdum. Condimentum lacinia quis vel eros donec ac. Mauris sit amet massa vitae tortor. Quisque id diam vel quam elementum pulvinar. Gravida in fermentum et sollicitudin ac orci phasellus. Facilisis gravida neque convallis a cras semper. Non arcu risus quis varius quam quisque id.",
  },
  {
    id: 7,
    question: "How do I make payment by my credit card?",
    answer:
      "At checkout, select 'Credit Card' and enter your card details securely.",
  },
];

export const stats = [
  { id: 1, icon: "bi bi-rulers", number: "560", label: "Total Area Sq" },
  { id: 2, icon: "bi bi-building", number: "197000", label: "Apartments Sold" },
  {
    id: 3,
    icon: "bi bi-cone-striped",
    number: "268",
    label: "Total Constructions",
  },
  { id: 4, icon: "bi bi-door-closed", number: "340", label: "Apartio Rooms" },
];

export const inspirehomedata = [
  {
    id: 1,
    title: "Build your dream home with Inspire Homes Australia!",
    description: `
      <ul>
        <li>Build on Vacant Land – Explore our innovative single and double-storey designs to make the most of your space.</li>
        <li>House & Land Packages – A stress-free process from land selection to home construction, customized to fit your budget and needs.</li>
        <li>Knockdown Rebuild – Love your location? Stay where you are while we rebuild a modern, high-quality home for you.</li>
      </ul>
    `,
  },
  {
    id: 2,
    title: "Quality Builds",
    description: `
      <ul>
        <li>Homes built using premium materials and skilled craftsmanship, ensuring durability and style.</li>
      </ul>
    `,
  },
  {
    id: 3,
    title: "Turnkey Service",
    description: `
      <ul>
        <li>Our turnkey service offers a hassle-free homebuilding experience from start to finish.</li>
      </ul>
    `,
  },
  {
    id: 4,
    title: "Something for Everyone",
    description: `
      <ul>
        <li>Diverse range of designs and customizable options, which cater to various lifestyles and budgets.</li>
      </ul>
    `,
  },
  {
    id: 5,
    title: "Locally Owned and Operated",
    description: `
      <ul>
        <li>As a proudly locally owned and operated company, we understand the unique needs of our community.</li>
      </ul>
    `,
  },
  {
    id: 6,
    title: "6 Years Structural Warranty",
    description: `
      <ul>
        <li>Enjoy peace of mind with our comprehensive 6-year structural warranty.</li>
      </ul>
    `,
  },
  {
    id: 7,
    title: "On Budget and On Time",
    description: `
      <ul>
        <li>Dedicated team works diligently to ensure all projects stay on schedule and within financial parameters.</li>
      </ul>
    `,
  },
];

export const addressInfo = [
  {
    icon: "bi-geo-alt",
    title: "Head Office",
    number: "0424 955 982",
    external: false,
    details: [
      {
        label: "5/429 High Street, Penrith, NSW 2750",
        href: "https://maps.app.goo.gl/r8dB3ALsBAQz8eUv5",
      },
    ],
  },
  {
    icon: "bi-geo",
    title: "Campbelltown Office",
    number: "0405253599",
    external: false,
    details: [
      {
        label: "182 Wyangala Crescent Leumeah 2560",
        href: "https://maps.app.goo.gl/MWj3wWsxyJB18Bg4A",
      },
    ],
  },
  {
    icon: "bi-pin-map",
    title: "Wagga Wagga Office",
    number: "0490874667",
    external: true,
    details: [
      {
        label: "13/64 Crampton Street, Wagga Wagga NSW 2650",
        href: "https://maps.app.goo.gl/Hzn2PhBS2dPhyUAA6",
      },
    ],
  },
];